import React, { useCallback, useEffect, useState } from 'react';
import './DependantForm.scss';
import GlobalParams from '../../helpers/GlobalParams.js';
import Form, { Item, GroupItem, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import { DataGrid, Column } from 'devextreme-react/data-grid';
import { Button, Lookup, TextBox, LoadPanel, DateBox, NumberBox, CheckBox, FileUploader } from 'devextreme-react';
import ApiHelper from '../../helpers/ApiHelper.js';
import LabelTemplate from '../../labels/LabelTemplate.js';
import ApiPostHelper from '../../helpers/ApiPostHelper.js';
import notify from 'devextreme/ui/notify';

function DependantForm({ onClosePopup, vsDeath, relation }) {

  const [isLoading, setIsLoading] = useState(false);
  var default_form = {
    Name: '',
    Relation: relation,
    dob: null,
    IDNumber: '',
    DeathCertNo: '',
    DeathEntryNo: '',
    BurialPermitNumber: ''
  }
  const [dependantStore, setDependantStore] = useState(default_form);
  const clear_form = () => {
    setDependantStore(default_form);
  }

  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };

  const doSave = useCallback(async (e) => {
    e.preventDefault();
    // Now you can submit the combined data to your backend or perform any other actions
    console.log('Submitted data:', dependantStore);

    clear_form();
    onClosePopup(dependantStore);
    //postDependant(claimStore);
  }, [dependantStore]);

  return (
    <div className="App">

      {isLoading && <LoadPanel visible={true} />}
      <br />
      <form onSubmit={doSave}>
        <Form
          formData={dependantStore}>
          <GroupItem colCount={2} caption="">

            <Item
              dataField="Name"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, Name: e.value });
                  }
                }
              }
            >
              <Label text='Name' />
            </Item>

            <Item
              dataField="Relation"
              editorType="dxLookup"
              editorOptions={
                {
                  dataSource: GlobalParams.RelationshipStore,
                  displayExpr: "name",
                  valueExpr: "id",
                  searchEnabled: false,
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, Relation: e.value });
                  },
                  value: relation
                }
              }
            >
              <RequiredRule message="Relationship" />
              <Label text='Relationship' />
            </Item>

            <Item
              dataField="dob"
              editorType="dxDateBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, dob: e.value });
                  }
                }
              }
            >
              <Label text='Date of Birth' />
            </Item>

            <Item
              dataField="IDNumber"
              editorType="dxTextBox"
              editorOptions={
                {
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, IDNumber: e.value });
                  }
                }
              }
            >
              <RequiredRule message="ID Number is Required" />
              <Label text='ID Number' />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />

            <Item
              dataField="DeathCertNo"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, DeathCertNo: e.value });
                  }
                }
              }
            >
              {/*vsDeath && <RequiredRule message="Death Cert No is required" />*/}
              <Label text='Death Cert No' />
            </Item>
            <Item
              dataField="DeathEntryNo"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, DeathEntryNo: e.value });
                  }
                }
              }
            >
              {/*vsDeath && <RequiredRule message="Death Entry No is required" />*/}
              <Label text='Death Entry Number' />
            </Item>
            <Item
              dataField="BurialPermitNumber"
              visible={vsDeath}
              editorType="dxTextBox"
              editorOptions={
                {
                  readOnly: false,
                  onValueChanged: (e) => {
                    setDependantStore({ ...dependantStore, BurialPermitNumber: e.value });
                  }
                }
              }
            >
              {/*vsDeath && <RequiredRule message="Burial Permit No is required" />*/}
              <Label text='Burial Permit Number' />
            </Item>

            <Item {...emptyItemConfig} />
            <Item {...emptyItemConfig} />


            <ButtonItem
              colSpan={2}
            >
              <ButtonOptions type='default' text="SUBMIT" icon='save' useSubmitBehavior={true} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </div>
  );
}
export default DependantForm;